export type Rating = 1 | 2 | 3 | 4;

export type FsrsCardState = 'new' | 'learning' | 'review' | 'relearning';

export interface FsrsState {
  stability: number;
  difficulty: number;
  reps: number;
  lapses: number;
  lastReview?: Date;
  state: FsrsCardState;
}

export interface FsrsSchedule {
  stability: number;
  difficulty: number;
  reps: number;
  lapses: number;
  intervalDays: number;
  nextReview: Date;
  state: FsrsCardState;
}

export interface FsrsParams {
  weights: number[];
  retentionTarget: number;
  maximumInterval: number;
}

export const RATING_AGAIN: Rating = 1;
export const RATING_HARD: Rating = 2;
export const RATING_GOOD: Rating = 3;
export const RATING_EASY: Rating = 4;